import ToggleButton from "@components/miscellany/toggle_button/toggle_button"
import store from '../../../../../store'
import('./button.css')

export default function Button(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let toggleButton
    let chart_name = opts.chart_name

    this.generate = () =>{
        let ids = store.getChartNestedProp(chart_name, 'stations_list.plu.ids') || []
        let current_show = store.getChartNestedProp(chart_name, 'series.rain.options.show')
        current_show = current_show === 'true'

        elements.container = this.createElement('div', 'mt-2')
        toggleButton = new ToggleButton({
            container:elements.container,
            states: [
                {title: 'Adicionar pluviométricos', classList: 'plu-stations-button-toggle', active: !(ids.length > 0 && current_show), id:'hide'},
                {title: 'Adicionar pluviométricos', classList: 'plu-stations-button-toggle active', active: (ids.length > 0 && current_show), id:'show'}
            ]
        })
        toggleButton.generate()

        toggleButton.on('click', state=>{
            context.trigger('click', state.toState.id == 'show')
        })

        $(container).append(elements.container)
    }

    this.update = () =>{

    }

    this.show = boolean =>{
        $(elements.container).toggle(boolean)
    }
}

Button.prototype = Object.create(BaseConstructor.prototype)